import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env/environment';

@Pipe({
  name: 'faceIdImageUrl',
})
export class FaceIdImageUrlPipe implements PipeTransform {
  transform(url: string): string {
    if (url) return url;
    const noAvatarSvgPath = 'assets/common/no-avatar.svg';
    if (environment.isGeotabEnv && environment.geotabDeployUrl) return `${environment.geotabDeployUrl}/${noAvatarSvgPath}`;
    return noAvatarSvgPath;
  }
}
